import { render, staticRenderFns } from "./FormMobile.vue?vue&type=template&id=7000c06a&"
import script from "./FormMobile.vue?vue&type=script&lang=js&"
export * from "./FormMobile.vue?vue&type=script&lang=js&"
import style0 from "./FormMobile.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports